module.exports = __webpack_public_path__ + "img/ql.28fc7712.png";